<template>
    <div class="d-flex flex-column h-100">

        <div class="sizing-container speech-bubble" :class="{'with-user': showUser}">
            <score v-if="showScore" :score="computedScore"/>
            <p>
                {{ text }}
            </p>
        </div>

        <user
            :user="user"
            :show-user="showUser"
        />
    </div>
</template>

<script>
    import Score from '@/components/carousels/components/Score';
    import User from '@/components/carousels/components/User';
    export default {
        name: 'SpeechCard',

        components: {
            Score,
            User
        },

        props: {
            text: {
                type: String,
                required: true
            },
            showScore: {
                type: Boolean,
                required: true
            },
            score: {
                type: Number,
                required: false,
                default: 4
            },
            showUser: {
                type: Boolean,
                required: true
            },
            user: {
                type: Object,
                required: true,
            }
        },


        computed: {
            computedScore() {
                return 5;
            }
        }
    }
</script>
